export const SEPARATOR_PLUGIN_KEY = 'separatorBLock';
export const SEPARATOR_TYPE = 'separatorBLock';
